export default "__VITE_ASSET__0a5f176f__"